import React from "react";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
export const StopPropagation = ({ children, stopHorizontalNavigation, stopVerticalNavigation }) => (React.createElement("span", Object.assign({ onClick: (e) => e.stopPropagation(), onFocus: (e) => e.stopPropagation() }, ((stopHorizontalNavigation || stopVerticalNavigation) && {
    onKeyDown: (e) => {
        if (e.key === "Tab" ||
            (stopHorizontalNavigation && ["ArrowLeft", "ArrowRight"].includes(e.key)) ||
            (stopVerticalNavigation && ["ArrowUp", "ArrowDown"].includes(e.key))) {
            e.stopPropagation();
        }
    },
})), children));
export const valueToString = (value) => (value === undefined || value === null ? "" : String(value));
export const updateFieldAtRowIndex = (data, rowIndex, field, newValue) => {
    const newData = cloneDeep(data);
    set(newData[rowIndex], field, newValue);
    return newData;
};
//# sourceMappingURL=TableCellContentUtils.js.map